<template>
    <Albums />
</template>

<script>
import Albums from '@/components/Albums.vue'
export default {
    name: 'albumview',
    components: {
        Albums,
    }
};
</script>